import { useQuery } from "@tanstack/react-query";
import {
  searchArticlesInMedias,
  getArticlesByHfb,
} from "../services/articles.service";
import { QueryKeys } from "./queryKeys";

export const useSearchArticlesInMedias = (
  storeId: string,
  searchQuery: string | undefined,
  hfb?: string
) => {
  const hasSearchQuery = !!searchQuery && searchQuery.length > 1;
  const enabled = hasSearchQuery || !!hfb;
  return useQuery({
    queryKey: [QueryKeys.SearchArticlesInMedias, { storeId, searchQuery, hfb }],
    queryFn: async () => {
      let results;
      if (hasSearchQuery) {
        results = await searchArticlesInMedias(storeId, searchQuery || "", hfb);
      } else if (hfb) {
        results = await getArticlesByHfb(storeId, hfb);
      }

      return results || [];
    },
    enabled,
  });
};
